import React from 'react';
import LocalizedDfpAd from './localized-dfp-ad';

class DfpAdInitDataDecorator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageTargeting: props.initData.gptData.customTargetingParameters,
            adUnitPath: props.initData.gptData.adUnitPath
        };
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.initData &&
            prevProps.initData.gptData &&
            prevProps.initData.gptData.customTargetingParameters
        ) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                pageTargeting:
                    prevProps.initData.gptData.customTargetingParameters,
                adUnitPath: prevProps.initData.gptData.adUnitPath
            });
        }
    }

    render() {
        return <LocalizedDfpAd {...this.state} {...this.props} />;
    }
}
export default DfpAdInitDataDecorator;
